import { useEffect } from 'react'
import { useAuthContext } from '../contexts'

export function LogoutPage() {
  const { signOut } = useAuthContext()

  useEffect(() => {
    signOut()
  }, [signOut])

  return <></>
}
